import { Component,ViewChild } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
import { FormGroup,FormControl,Validators } from '@angular/forms';
import { getLocalJSON } from '../../_helpers/storage.util';
import { transactionStatusLabel, transactionTitle, transactionTypeLabel } from '../../_helpers/payments.util';
declare var $:any;

@Component({
  selector: 'app-purchase',
  templateUrl: './purchase.component.html',
  styleUrls: ['./purchase.component.scss']
})
export class PurchaseComponent {

  public statusLabel = transactionStatusLabel;
  public typeLabel = transactionTypeLabel;
  public titleLabel = transactionTitle;

  public loading:boolean = false;
  public PurchaseList:any=[];
  public totalCount: number = 0;
  public p = 1;
  public pageLimit = 10;
  public previousLabel:any='';
  public nextLabel:any='';
  public loginDetail:any =[];

  constructor(public router: Router, public service: GlobalService) { 
    this.loginDetail = getLocalJSON('grw_login');
    this.getPurchase();
   }

   ngOnInit(): void {
  }

  getPurchase(){
    const url = "/transactions"; 
    this.service.GetApi(url).subscribe(((response:any)=>{
      if(response.success ==1) {
        var self =this;
        response.data.data.filter((el:any)=>{
          // el.dates = self.service.ToDate(el.date);   
          el.amounts= parseFloat(el.amount).toFixed(2)  ;     
        })
        this.totalCount = response.data.total;
        this.PurchaseList = response.data.data;
      }
    }), (error) => { this.loading =false; });
  }

  getPurchaseDetail(id:any){
    const url = "/transactions-detail?tran_id=" +id; 
    this.service.GetApi(url).subscribe(((response:any)=>{
      if(response.success ==1) {
        console.log(response.data)
        // var self =this;
        // response.data.data.filter((el:any)=>{
        //   // el.dates = self.service.ToDate(el.date);   
        //   el.amounts= parseFloat(el.amount).toFixed(2)  ;     
        // })
        // this.totalCount = response.data.total;
        // this.PurchaseList = response.data.data;
      }
    }), (error) => { this.loading =false; });
  }
}
